<template>
  <div id="list-partner">
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              v-if="partners.length > 0"
              :headers="headers"
              :items="partners"
              :items-per-page="10"
              class="table-cursor"
              @click:row="(item) => goToPartner(item)"
            >
              <template v-slot:item.updatedAt="{ item }">{{
                getInternationalDate(item.updatedAt)
              }}</template>
            </v-data-table>
            <v-skeleton-loader
              v-else
              :loading="isLoading"
              type="table"
            ></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { toRefs, onMounted, onBeforeMount } from "@vue/composition-api";
import { usePartner } from "../composables/partner";
import { useTitle } from "@/composables/title";
import router from "@/router";
import { date } from "../composables/date";

export default {
  setup() {
    /* Import des API */
    const { setTitle, setIcon } = useTitle();
    const { partnerData, listPartners } = usePartner();
    const { getInternationalDate } = date();

    /* Cycle de vie */
    onBeforeMount(() => {
      setTitle("Partenaires");
      setIcon("partenaire");
    });
    onMounted(() => {
      listPartners();
    });

    /* Variables */
    const headers = [
      { text: "Nom", value: "name" },
      { text: "Maj le", value: "updatedAt" },
    ];

    /* Méthodes */
    const goToPartner = function (item) {
      router.push({ name: "partenaire-details", params: { id: item.id } });
    };

    return {
      ...toRefs(partnerData),
      headers,
      goToPartner,
      getInternationalDate,
    };
  },
};
</script>
